import { render, staticRenderFns } from "./AddContent.vue?vue&type=template&id=238e33ce&scoped=true&"
import script from "./AddContent.vue?vue&type=script&lang=js&"
export * from "./AddContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238e33ce",
  null
  
)

export default component.exports